<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '90vw', height: '90vh', maxWidth: '1200px' }"
  [contentStyle]="{ padding: '0', height: 'calc(90vh - 120px)' }"
  (onHide)="onHide()">
  <ng-template #header>
    <div class="flex items-center justify-between w-full">
      <div class="flex items-center gap-3">
        <i class="pi pi-file-pdf text-red-500 text-xl"></i>
        <span class="font-semibold text-lg">{{ filename || 'Document Preview' }}</span>
      </div>
      <p-button
        icon="pi pi-download"
        [label]="'common.download' | translate"
        severity="secondary"
        size="small"
        (onClick)="downloadPdf()"
        [disabled]="!pdfBase64" />
    </div>
  </ng-template>

  <div class="w-full h-full flex flex-col">
    <div *ngIf="!pdfBase64" class="flex items-center justify-center h-full">
      <div class="text-center">
        <i class="pi pi-file-pdf text-gray-400 text-6xl mb-4"></i>
        <p class="text-gray-500">{{ 'common.noDataFound' | translate }}</p>
      </div>
    </div>

    <iframe *ngIf="visible && pdfBase64" [src]="pdfUrl" class="w-full h-full border-0 rounded" [title]="filename"> </iframe>
  </div>
</p-dialog>
